import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewAllowedAuthorType', {
  EVERYONE: 10,
  MEMBER_ONLY: 20,
  BUYER_ONLY: 30,
  DELIVERY_FINISHED_BUYER_ONLY: 40
});
